//icons
import { GiMoneyStack } from "react-icons/gi";
import { AiOutlineHome, AiOutlineTeam } from "react-icons/ai";
import { VscTypeHierarchySub } from "react-icons/vsc";
import { GiPartyPopper } from "react-icons/gi";
import { FiUsers } from "react-icons/fi";
import { TfiAnnouncement } from "react-icons/tfi";
import { CiCalendarDate } from "react-icons/ci";
import { RiTimerFlashLine } from "react-icons/ri";
import { IoFingerPrintOutline } from "react-icons/io5";
import { TbReportSearch, TbReportMoney } from "react-icons/tb";
import { HiOutlinePresentationChartLine } from "react-icons/hi";
import { CgUserList } from "react-icons/cg";
import { LiaMoneyCheckAltSolid } from "react-icons/lia";
import { IoMdSettings } from "react-icons/io";
import { BsStars } from "react-icons/bs";
import { FaBusinessTime } from "react-icons/fa";

const SidebarLinks = [
  {
    id: 1,
    name: "الرئيسية",
    icon: <AiOutlineHome size={18} />,
    path: "/",
    sub: [],
    roles: [
      "user",
      "manager",
      "super-admin",
      "reception",
      "finance",
      "reception_supervisor",
    ],
  },
  {
    id: 2,
    name: " الاحصائيات",
    icon: <HiOutlinePresentationChartLine size={20} />,
    path: "/statistics",
    sub: [],
    roles: ["super-admin"],
  },
  {
    id: 3,
    name: "الموظفين",
    icon: <FiUsers size={18} />,
    path: "/employee",
    sub: [],
    roles: ["super-admin", "reception", "finance", "reception_supervisor"],
  },
  {
    id: 19,
    name: "تقييم الموظفين",
    icon: <BsStars size={18} />,
    path: "/employee-ratings",
    sub: [],
    roles: ["super-admin", "manager"],
    has_team_required: true,
  },
  {
    id: 4,
    name: "تغيير الشفت",
    icon: <CgUserList size={18} />,
    path: "/shifts",
    sub: [],
    roles: ["super-admin", "reception", "reception_supervisor"],
  },
  {
    id: 5,
    name: "بصماتي",
    icon: <IoFingerPrintOutline size={18} />,
    path: "/my-attendance",
    sub: [],
    roles: [
      "user",
      "manager",
      "super-admin",
      "reception",
      "finance",
      "reception_supervisor",
    ],
  },
  {
    id: 6,
    name: "الحضور و الأنصراف",
    icon: <IoFingerPrintOutline size={18} />,
    path: "/attendance",
    sub: [],
    roles: ["super-admin", "manager", "reception_supervisor", "reception"],
    has_team_required: true,
  },
  {
    id: 62,
    name: "اعضاء الفريق",
    icon: <AiOutlineTeam size={18} />,
    path: "/team-leader",
    sub: [],
    roles: ["manager"],
    has_team_required: true,
  },
  {
    id: 7,
    name: "الأقسام",
    icon: <VscTypeHierarchySub size={18} />,
    path: "/departments",
    sub: [],
    roles: ["super-admin"],
  },
  {
    id: 8,
    name: "الإعلانات",
    icon: <TfiAnnouncement size={18} />,
    path: "/announcements",
    sub: [],
    roles: ["super-admin"],
  },
  {
    id: 9,
    name: "العطلات",
    icon: <GiPartyPopper size={20} />,
    path: "/holidays",
    sub: [],
    roles: ["super-admin"],
  },
  {
    id: 10,
    name: "اوقات السماح",
    icon: <RiTimerFlashLine size={20} />,
    path: "/flexibility",
    sub: [],
    roles: ["super-admin"],
  },
  {
    id: 11,
    name: "الآجازات",
    icon: <CiCalendarDate size={20} />,
    path: "/leave",
    sub: [],
    roles: [
      "user",
      "manager",
      "super-admin",
      "reception",
      "finance",
      "reception_supervisor",
    ],
  },
  {
    id: 12,
    name: "التبليغات و الأشعارات",
    icon: <CiCalendarDate size={20} />,
    path: "/notifications",
    sub: [],
    roles: [
      "user",
      "manager",
      "super-admin",
      "reception",
      "finance",
      "reception_supervisor",
    ],
  },
  {
    id: 13,
    name: "التقارير",
    icon: <TbReportSearch size={20} />,
    path: "/reports",
    sub: [],
    roles: ["super-admin", "reception", "finance", "reception_supervisor"],
  },
  {
    id: 14,
    name: "المكافئات و الخصومات",
    icon: <LiaMoneyCheckAltSolid size={20} />,
    path: "/bonuses-cuts",
    sub: [],
    roles: ["super-admin", "manager", "finance", "user"],
  },
  {
    id: 140,
    name: "مكافئات الساعات الاضافية",
    icon: <FaBusinessTime size={20} />,
    path: "/overtime",
    sub: [],
    roles: ["super-admin", "manager", "finance", "user"],
  },
  {
    id: 15,
    name: "القروض",
    icon: <TbReportMoney size={20} />,
    path: "/advance-payment",
    sub: [],
    roles: ["super-admin", "finance"],
  },
  {
    id: 16,
    name: "الرواتب",
    icon: <GiMoneyStack size={20} />,
    path: "/salary",
    sub: [],
    roles: ["super-admin", "finance"],
  },
  {
    id: 17,
    name: "ادارة الرواتب",
    icon: <GiMoneyStack size={20} />,
    path: "/manage-salary",
    sub: [],
    roles: ["super-admin", "finance"],
  },
  {
    id: 18,
    name: "الاعدادات",
    icon: <IoMdSettings size={20} />,
    path: "/settings",
    sub: [],
    roles: ["super-admin", "reception_supervisor"],
  },
];

export default SidebarLinks;
